import KendoDiagram from '../KendoDiagram'
import KendoDiagramConnection from '../KendoDiagramConnection'
import KendoDiagramShape from '../KendoDiagramShape'

let KendoDiagramInstaller = class {
    static install(Vue) {
        Vue.component(KendoDiagram.name, KendoDiagram)
        Vue.component(KendoDiagramConnection.name, KendoDiagramConnection)
        Vue.component(KendoDiagramShape.name, KendoDiagramShape)
    }
}

export default KendoDiagramInstaller

// Automatic installation if Vue has been added to the global scope.
if (typeof window !== 'undefined' && window.Vue && window.Vue.use) {
    window.Vue.use(KendoDiagramInstaller)
}


// WEBPACK FOOTER //
// ./packages/kendo-diagram-vue-wrapper/src/kendo-diagram-installer/index.js